module.exports = __webpack_public_path__ + "img/snx.6439e5a7.svg";